/**
 * PDF.js bootstrap — self-hosted (no CDN), worker bundled by Vite.
 *
 * pdfjs-dist v4 ships a worker as a separate ESM module. Vite resolves
 * the ?url query parameter to a hashed asset URL at build time, so the
 * SPA never reaches out to a CDN (souveraineté ADR-014/015).
 */

import * as pdfjs from 'pdfjs-dist';
// @ts-expect-error — Vite resolves ?url to a string asset URL at build
import workerUrl from 'pdfjs-dist/build/pdf.worker.min.mjs?url';

pdfjs.GlobalWorkerOptions.workerSrc = workerUrl as string;

export const getDocument = pdfjs.getDocument;
export type PDFDocumentProxy = pdfjs.PDFDocumentProxy;
export type PDFPageProxy = pdfjs.PDFPageProxy;
